import React, { useEffect, useState } from "react";
import { Wrapper } from "../components/Wrapper";
import { PageTitle } from "../components/PageTitle";
import { CustomTable } from "../components/CustomTable";
import { useNavigate } from "react-router-dom";
import { Notification } from "../utils/Notification";
import { useMutation, useQuery } from "@apollo/client";
import i18next from "i18next";
import { GET_COMPLEXES } from "../graphql/Queries/ComplexQuery";
import { DELETE_COMPLEX } from "../graphql/Mutations/ComplexMutation";

export const Complexes = ({ url }) => {
  const [items, setItems] = useState([]);
  const navigator = useNavigate();

  const { data } = useQuery(GET_COMPLEXES, {
    fetchPolicy: "no-cache",
    variables: {
      lang: i18next.language,
    },
  });
  const [removeComplex] = useMutation(DELETE_COMPLEX);

  useEffect(() => {
    if (data) {
      setItems(data.complex);
    }
  }, [data]);

  const remove = (id) => {
    removeComplex({
      variables: {
        id: Number(id),
      },
    })
      .then((response) => {
        setItems(response.data.deleteComplex);
      })
      .catch((error) => {
        Notification(error);
      });
  };

  const edit = (id) => {
    navigator(`${url}/form?id=${id}`);
  };

  return (
    <Wrapper>
      <PageTitle title={"Жилые зоны"} />
      <div className="row">
        <div className="col-md-12">
          <div className="card">
            <div className="card-body">
              <CustomTable
                data={items}
                columns={[
                  { key: "id", label: "ID" },
                  { key: "name", label: "Название" },
                  { key: "address", label: "Адрес" },
                ]}
                search={true}
                sort={true}
                pagination={{
                  limit: 10,
                }}
                actions={[
                  {
                    slug: `${url}/form`,
                    icon: "fe-plus",
                    name: "Создать",
                  },
                  {
                    slug: `${url}/props`,
                    icon: "fe-bar-chart-2",
                    name: "Свойства",
                  },
                ]}
                onClick={(id) => edit(id)}
                onDelete={(id) => remove(id)}
              />
            </div>
          </div>
        </div>
      </div>
    </Wrapper>
  );
};
